import GoogleAuthButton from './GoogleAuthButton';
import { GOOGLE_CLIENT_ID } from '../../config';
import { Link } from 'react-router-dom';

export const IconCheck = (props) => (
  <svg viewBox="0 0 16 16" aria-hidden="true" {...props}>
    <path fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" d="M2 8.5 6 12.5 14 3.5" />
  </svg>
);

export const IconWarn = () => (
  <svg viewBox="0 0 16 16" aria-hidden="true">
    <circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8 4.4v4.2" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
    <circle cx="8" cy="11.4" r="1" fill="currentColor" />
  </svg>
);

export const IconEye = ({ off }) =>
  off ? (
    <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
      <path d="M3 3l18 18" />
      <path d="M10.6 6.3A9.7 9.7 0 0112 6.2c5 0 9 5.8 9 5.8a17 17 0 01-3.2 3.7M6.4 8.3A17.6 17.6 0 003 12s4 5.8 9 5.8a9 9 0 003.4-.7" />
      <path d="M9.9 9.9a3 3 0 004.2 4.2" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
      <path d="M3 12s4-5.8 9-5.8S21 12 21 12s-4 5.8-9 5.8S3 12 3 12z" />
      <circle cx="12" cy="12" r="2.9" />
    </svg>
  );

export function AuthBrand() {
  return (
    <Link className="ax-brand" to="/" aria-label="TeamGrid home">
      <img src="/assets/mark-teamgrid.svg" alt="" />
      <b>TeamGrid</b>
    </Link>
  );
}

/** Single sign-on options. Presentational in this build. */
export function SsoRow({ verb = 'Continue', onCredential, onError, disabled }) {
  /* Microsoft was removed: the product has no Microsoft SSO, so the button
     could never have worked. Google is real — see GoogleAuthButton. If Google
     isn't configured, this renders nothing rather than an empty divider. */
  const btn = (
    <GoogleAuthButton verb={verb} onCredential={onCredential} onError={onError} disabled={disabled} />
  );
  if (!GOOGLE_CLIENT_ID) return null;
  return <div className="ax-sso ax-sso-single">{btn}</div>;
}
export function AuthSide({ eyebrow, title, points, quote, who, role, initials, stats }) {
  return (
    <aside className="ax-side">
      <div className="ax-sin">
        <span className="ax-eyebrow">{eyebrow}</span>
        <h2>{title}</h2>
        <ul className="ax-pts">
          {points.map((p) => (
            <li key={p.b}>
              <IconCheck style={{ color: '#00D1C1' }} />
              <span><b>{p.b}</b> {p.t}</span>
            </li>
          ))}
        </ul>
        <div className="ax-quote">
          <p>“{quote}”</p>
          <div className="ax-who">
            <span className="av">{initials}</span>
            <span>
              <span className="n">{who}</span>
              <span className="r">{role}</span>
            </span>
          </div>
        </div>
        <div className="ax-stats">
          {stats.map((s) => (
            <div className="ax-stat" key={s.l}>
              <div className="v">{s.v}</div>
              <div className="l">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </aside>
  );
}
